import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'

export default {
    path: '/settings',
    meta: { middleware: [authorized], layout: "default", rights: ['settings'] },
    component: () => import('../components/pages/settings/SettingsGeneral.vue'),
    children: [
        { path: '', redirect: '/settings/clinic' },
        {
            path: 'clinic', name: "SettingsClinic",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsClinic.vue')
        },
        {
            path: 'contacts', name: "SettingsContacts",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsContacts.vue')
        },
        {
            path: 'calendar', name: "SettingsCalendar",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsCalendar.vue')
        },
        {
            path: 'currencies', name: "SettingsCurrencies",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'clinic_currencies'] },
            component: () => import('../components/pages/settings/SettingsCurrencies.vue')
        },
        {
            path: 'integrations', name: "SettingsIntegrations",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'], countries: ['RU'] },
            component: () => import('../components/pages/settings/SettingsIntegrations.vue')
        },
        {
            path: 'tags', name: "SettingsTags",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsTags.vue')
        },
        {
            path: 'record_tags', name: "SettingsRecordTags",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsRecordTags.vue')
        },
        {
            path: 'visit_results', name: "SettingsVisitResults",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsVisitResults.vue')
        },
        {
            path: 'sources', name: "SettingsSources",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsSources.vue')
        },
        {
            path: 'pay_methods', name: "SettingsPayMethods",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsPayMethods.vue')
        },
        {
            path: 'record_types', name: "SettingsRecordTypes",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsRecordTypes.vue')
        },
        {
            path: 'deposit_accounts', name: "SettingsDepositAccounts",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsDepositAccounts.vue')
        },
        {
            path: 'fields', name: "SettingsFields",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsFields.vue')
        },
        {
            path: 'treatment_card', name: "SettingsTreatmentCard",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsTreatmentCard.vue')
        },
        {
            path: 'notifications', name: "SettingsNotifications",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'notifications'] },
            component: () => import('../components/pages/settings/SettingsNotifications.vue')
        },
        {
            path: 'conditions', name: "SettingsPatientConditions",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'patient_conditions'] },
            component: () => import('../components/pages/settings/SettingsPatientConditions.vue')
        },
        {
            path: 'templates', name: "SettingsTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsTemplates.vue')
        },
        {
            path: 'reasons', name: "SettingsRecordReasons",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsRecordReasons.vue')
        },
        {
            path: 'bonuses', name: "SettingsBonuses",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'bonuses'] },
            component: () => import('../components/pages/settings/SettingsBonuses.vue')
        },
        {
            path: 'online_booking', name: "SettingsOnlineBooking",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'online_booking'] },
            component: () => import('../components/pages/settings/SettingsOnlineBooking.vue')
        },
        {
            path: 'control_system', name: "SettingsControlSystem",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'control_system'] },
            component: () => import('../components/pages/settings/SettingsControlSystem.vue')
        },
        {
            path: 'egisz', name: "SettingsEGISZ",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'egisz_view'], countries: ['RU'] },
            component: () => import('../components/pages/settings/SettingsEGISZ.vue')
        },
        {
            path: 'ips', name: "SettingsIPs",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsIPs.vue')
        },
        {
            path: 'anketa', name: "SettingsAnketa",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings'] },
            component: () => import('../components/pages/settings/SettingsAnketa.vue')
        },
        {
            path: 'telegram_bot', name: "SettingsTelegramBot",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'telegram_bot'], countries: ['RU'] },
            component: () => import('../components/pages/settings/SettingsTelegramBot.vue')
        },
        {
            path: 'max_bot', name: "SettingsMaxBot",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['settings', 'max_bot'], countries: ['RU'] },
            component: () => import('../components/pages/settings/SettingsMaxBot.vue')
        },
    ]
}
